// La Clica food-vendor secondary: frutero umbrella.
// Silhouette = tall square umbrella in tricolor (green/white/red) panels + pole.
// The Mexican-flag umbrella is visible from a block away; it IS the vendor's signal.

interface FruteroUmbrellaProps {
  /** Pole / structural color. */
  bodyColor?: string;
  /** Accent — chamoy bottle, the saturation in the umbrella. */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function FruteroUmbrella({
  bodyColor = '#c8b89a',
  accentColor = '#5a1818',
  size = 48,
  className,
}: FruteroUmbrellaProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Umbrella — green panel left */}
      <path d="M4 16 L18 14 L18 22 L4 22 Z" fill="#0a8a3a" />
      {/* Umbrella — white panel center */}
      <path d="M18 14 L30 14 L30 22 L18 22 Z" fill="#f5ecd6" />
      {/* Umbrella — red panel right */}
      <path d="M30 14 L44 16 L44 22 L30 22 Z" fill="#c8102e" />
      {/* Umbrella top peak */}
      <path d="M22 8 L24 6 L26 8 L26 14 L22 14 Z" fill="#c8102e" />
      {/* Umbrella bottom edge — scalloped */}
      <path
        d="M4 22 Q6 25 8 22 Q10 25 12 22 Q14 25 16 22 Q18 25 20 22 Q22 25 24 22 Q26 25 28 22 Q30 25 32 22 Q34 25 36 22 Q38 25 40 22 Q42 25 44 22"
        stroke={bodyColor}
        strokeWidth="0.8"
        fill="none"
      />
      {/* Pole */}
      <rect x="23" y="22" width="2" height="20" fill={bodyColor} />
      {/* Glass case below — fruit display */}
      <rect x="14" y="32" width="20" height="10" rx="1" fill="rgba(245,236,214,0.2)" stroke={bodyColor} strokeWidth="0.8" />
      {/* Fruit chunks — mango (yellow), watermelon (red) */}
      <circle cx="18" cy="36" r="2" fill="#d4a945" />
      <circle cx="24" cy="36" r="2" fill={accentColor} />
      <circle cx="30" cy="36" r="2" fill="#d4a945" />
      <circle cx="20" cy="40" r="1.5" fill={accentColor} />
      <circle cx="28" cy="40" r="1.5" fill={accentColor} />
    </svg>
  );
}
